import React, { useEffect, useState } from "react";
import {
  SafetyOutlined,
  UserOutlined,
  DashboardOutlined,
  ShopOutlined,
  DesktopOutlined,
  DollarOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Menu, Modal, Spin } from "antd";
import { phototime_logo } from "../../assets";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";
import withRouter from "../../hocs/withRouter";
import { useAccountStore, useAuthStore, useCommonStore } from "../../store";
import icons from "../../ultils/icons";
import {
  useAddAccountForStoreApi,
  useGetAllStoreApi,
  useGetInfoApi,
} from "../../hooks";
import { ROLE } from "../../ultils/constants";
import ModelNext from "./ModelNext";
import { ModalBody, ModalHeader } from "@nextui-org/react";
import { Select, SelectItem } from "@nextui-org/react";
import ButtonCustom from "./ButtomCustom";
import { FaRegCheckSquare, FaUserCog } from "react-icons/fa";
import toast from "react-hot-toast";
import { MdDiscount } from "react-icons/md";
import { PiFrameCorners } from "react-icons/pi";
import { IoSettingsSharp } from "react-icons/io5";
import { MdOutlineSwapHoriz } from "react-icons/md";
import api from "../../config/client.axios.api";
import axios from "axios";

type MenuItem = Required<MenuProps>["items"][number];

const Sidebar: React.FC = ({
  dataModelUpdateInfo,
  dataModelUpdatePassword,
  dataModelAddAccountForStore,
}: any) => {
  const [stateOpenKeys, setStateOpenKeys] = useState([path.STATISTICAL_MANAGE]);
  const navigate = useNavigate();

  const [dataAddAccountForStore, setDataAddAccountForStore] = useState({
    accountId: "",
    groupId: "",
  });
  const { setReloadInfo, reloadInfo } = useCommonStore();
  const [isChangePassword, setIsChangePassword] = useState(false);

  // store
  const { clearToken } = useAuthStore();
  const { setInfo } = useAccountStore();
  const { reload } = useCommonStore();

  // api info
  const { infoDetail, isLoading } = useGetInfoApi(clearToken, reloadInfo);
  const [allAccount, setAllAccount] = useState<any>(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resetPassword, setResetPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [infomationUpdate, setInfomationUpdate] = useState({
    imageUrl: "",
    firstName: "",
    lastName: "",
  });

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    const res = await api.put(
      `/account?id=${infoDetail?.data?.id}`,
      infomationUpdate
    );

    setReloadInfo(!reloadInfo);

    if (isChangePassword) {
      const resultChangePassword = await api.put(
        `/account/password`,
        resetPassword
      );
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const { allStore } = useGetAllStoreApi(
    dataModelAddAccountForStore.isOpenAddAccountForStore
  );

  useEffect(() => {
    setInfo(infoDetail?.data);
    setInfomationUpdate({
      imageUrl: infoDetail?.data?.imageUrl,
      firstName: infoDetail?.data?.firstName,
      lastName: infoDetail?.data?.lastName,
    });
  }, [isLoading, infoDetail?.data]);

  const { isSidebarOpen, setIsSidebarOpen } = useCommonStore();

  const { IoMdClose, IoIosLogOut } = icons;

  const onOpenChange: MenuProps["onOpenChange"] = (openKeys) => {
    setStateOpenKeys(openKeys);
  };

  const items: MenuItem[] = [
    {
      key: path.STATISTICAL,
      icon: <DashboardOutlined />,
      label: "Statistical",
      children: [{ key: path.STATISTICAL_MANAGE, label: "Statistical" }],
    },
    ...(infoDetail?.data?.role === ROLE.ROLE_ADMIN
      ? [
          {
            key: path.FRAME,
            icon: <PiFrameCorners />,
            label: "Frames",
            children:
              infoDetail?.data?.role === ROLE.ROLE_ADMIN
                ? [{ key: path.FRAME_ANALYSTIC, label: "Manage Frame" }]
                : [],
          },
        ]
      : []),
    {
      key: path.REVENUE,
      icon: <DollarOutlined />,
      label: "Revenue",
      children:
        infoDetail?.data?.role === ROLE.ROLE_ADMIN
          ? [
              { key: path.REVENUE_STORE, label: "Revenue Store" },
              { key: path.REVENUE_MACHINE, label: "Revenue Machine" },
            ]
          : [
              { key: path.REVENUE_STORE_USER, label: "Revenue Store" },
              { key: path.REVENUE_MACHINE_USER, label: "Revenue Machine" },
            ],
    },
    {
      key: path.STORE,
      icon: <ShopOutlined />,
      label: "Store",
      children:
        infoDetail?.data?.role === ROLE.ROLE_ADMIN
          ? [{ key: path.STORE_MANAGE, label: "Manage Store" }]
          : [{ key: path.MY_STORE, label: "My Store" }],
    },
    {
      key: path.MACHINE,
      icon: <DesktopOutlined />,
      label: "Machine",
      children:
        infoDetail?.data?.role === ROLE.ROLE_ADMIN
          ? [{ key: path.MACHINE_MANAGE, label: "Manage Machine" }]
          : [{ key: path.MACHINE_USER_MANAGE, label: "My Machine" }],
    },
    ...(infoDetail?.data?.role === ROLE.ROLE_ADMIN
      ? [
          {
            key: path.USER,
            icon: <UserOutlined />,
            label: "Users",
            children: [
              { key: path.USER_MANAGER, label: "Manage User" },
              { key: path.USER_CREATE, label: "Create User" },
            ],
          },
        ]
      : []),
    // ...(infoDetail?.data?.role === ROLE.ROLE_ADMIN
    //   ? [
    //       {
    //         key: path.TRACKING,
    //         icon: <FaRegCheckSquare />,
    //         label: "Tracking",
    //         children: [
    //           { key: path.RESULT, label: "Manage Result" },
    //           { key: path.TYPE_TRANSACTION, label: "Manage Type Transaction" },
    //           { key: path.SOLUTION, label: "Manage Solution" },
    //         ],
    //       },
    //     ]
    //   : []),
    // ...(infoDetail?.data?.role === ROLE.ROLE_ADMIN
    //   ? [
    //       {
    //         key: path.VOUCHER,
    //         icon: <MdDiscount />,
    //         label: "Vouchers",
    //         children:
    //           infoDetail?.data?.role === ROLE.ROLE_ADMIN
    //             ? [{ key: path.VOUCHER_MANAGE, label: "Manage Voucher" }]
    //             : [],
    //       },
    //     ]
    //   : []),
    ...(infoDetail?.data?.role === ROLE.ROLE_ADMIN ||
    infoDetail?.data?.role === ROLE.ROLE_STAFF
      ? [
          {
            key: path.TRANSACTION,
            icon: <MdOutlineSwapHoriz />,
            label: "Transaction Management",
            children: [
              { key: path.TRANSACTION_MANAGE, label: "Manage Transaction" },
            ],
          },
        ]
      : []),
  ];

  // onClick of menu
  const onMenuClick: MenuProps["onClick"] = ({ key }) => {
    if (key === "logout") {
      localStorage.removeItem("token");
      navigate(path.SIGN_IN);
    } else if (key === path.ACCOUNT_UPDATE_INFO) {
      dataModelUpdateInfo.onOpen();
    } else if (key === path.ACCOUNT_UPDATE_PASSWORD) {
      dataModelUpdatePassword.onOpenChangePassword();
    } else if (key === path.STORE_ADD_ACCOUNT) {
      dataModelAddAccountForStore.onOpenChangeAddAccountForStore();
    } else {
      navigate(key);
      setStateOpenKeys([key]);
    }

    if (window.innerWidth < 768) {
      setIsSidebarOpen(false);
    }
  };

  const handleLogout = () => {
    clearToken();
    setIsSidebarOpen(false);
    navigate(path.SIGN_IN);
  };

  // api add account for store
  const { mutate: $handleAddAccount, isPending: isPendingAddAccount } =
    useAddAccountForStoreApi();

  const handleAddAccount = async () => {
    $handleAddAccount(dataAddAccountForStore, {
      onSuccess: (response: any) => {
        if (response?.code === 200 || response?.message === 200) {
          toast.success("Add account successfully !");
          dataModelAddAccountForStore.onCloseAddAccountForStore();
        } else {
          toast.error(response?.error || "Add Account for store failure !");
        }
      },
      onError: (error: any) => {
        toast.error(
          error?.response?.data?.error || "Add Account for store failure !"
        );
      },
    });
  };

  return (
    <>
      {/* Model add account for store */}
      <ModelNext
        isOpen={dataModelAddAccountForStore.isOpenAddAccountForStore}
        onOpen={dataModelAddAccountForStore.onOpenAddAccountForStore}
        onOpenChange={
          dataModelAddAccountForStore.onOpenChangeAddAccountForStore
        }
      >
        <ModalHeader className="flex flex-col gap-1 lg:text-base text-base text-[#b1b0b0]">
          Add Account For Store
        </ModalHeader>
        <ModalBody>
          <div
            key={allAccount?.data?.length}
            className="md:flex-row flex flex-col gap-4"
          >
            <Select
              onChange={(value: any) => {
                setDataAddAccountForStore({
                  ...dataAddAccountForStore,
                  groupId: value?.target?.value,
                });
              }}
              label="Select store"
              className="max-w-xs"
            >
              {allStore &&
                allStore?.data?.map((store: any) => (
                  <SelectItem key={store?.groupId}>{store?.groupId}</SelectItem>
                ))}
            </Select>
            <Select
              onChange={(value: any) => {
                setDataAddAccountForStore({
                  ...dataAddAccountForStore,
                  accountId: value?.target?.value,
                });
              }}
              value={dataAddAccountForStore.accountId}
              label="Select account"
              className="max-w-xs"
            >
              {allAccount &&
                allAccount?.data?.map((account: any) => (
                  <SelectItem value={account?.id} key={account?.id}>
                    {allAccount?.data?.find(
                      (item: any) => item?.id === account?.id
                    )?.firstName +
                      " " +
                      allAccount?.data?.find(
                        (item: any) => item?.id === account?.id
                      )?.lastName}
                  </SelectItem>
                ))}
            </Select>
          </div>
          <ButtonCustom
            onClick={handleAddAccount}
            variant="primary"
            size="md"
            className="w-full bg-[#b1b0b0] hover:bg-[#b1b0b0] hover:bg-opacity-70 flex justify-center items-center gap-3 text-white"
          >
            <span className="md:text-sm">Add Account</span>
            {isPendingAddAccount ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    className="white-spinner-icon text-white"
                    spin
                  />
                }
                size="small"
              />
            ) : (
              <FaUserCog className="lg:text-[1.4rem] text-[1.3rem]"></FaUserCog>
            )}
          </ButtonCustom>
        </ModalBody>
      </ModelNext>
      <Modal
        title="Update Infomation"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col">
          <span className="font-semibold">Change infomation</span>
          <div className="flex flex-col w-full gap-1">
            {infomationUpdate?.imageUrl && (
              <img
                className="w-[50px] h-[50px] rounded-full"
                src={infomationUpdate?.imageUrl}
              ></img>
            )}
            <input
              onChange={async (event: any) => {
                const formData = new FormData();
                formData.append("image", event.target.files[0]);

                const res = await axios.post(
                  `https://backendapp.phototime.biz/v2/upload/upload`,
                  formData
                );

                setInfomationUpdate((prev) => ({
                  ...prev,
                  imageUrl: res?.data?.data?.url,
                }));
              }}
              type="file"
              accept=".png, .jpg, .jpeg"
              className="fill-none my-3"
            />
          </div>
          <div className="flex flex-col w-full">
            <span>First name</span>
            <input
              onChange={(e) => {
                setInfomationUpdate((prev) => ({
                  ...prev,
                  firstName: e.target.value,
                }));
              }}
              value={infomationUpdate?.firstName}
              className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
            ></input>
          </div>
          <div className="flex flex-col w-full">
            <span>Last name</span>
            <input
              onChange={(e) => {
                setInfomationUpdate((prev) => ({
                  ...prev,
                  lastName: e.target.value,
                }));
              }}
              value={infomationUpdate?.lastName}
              className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
            ></input>
          </div>
        </div>
        <small
          className="underline cursor-pointer"
          onClick={() => {
            setIsChangePassword(!isChangePassword);
          }}
        >
          Change password
        </small>
        {isChangePassword && (
          <div className="flex flex-col mt-1">
            <span className="font-semibold">Change password</span>
            <div className="flex flex-col w-full">
              <span>Password current</span>
              <input
                onChange={(e) => {
                  setResetPassword((prev) => ({
                    ...prev,
                    oldPassword: e.target.value,
                  }));
                }}
                type="password"
                className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
              ></input>
            </div>
            <div className="flex flex-col w-full">
              <span>New password</span>
              <input
                onChange={(e) => {
                  setResetPassword((prev) => ({
                    ...prev,
                    newPassword: e.target.value,
                  }));
                }}
                type="password"
                className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
              ></input>
            </div>
            <div className="flex flex-col w-full">
              <span>Confirm new password</span>
              <input
                onChange={(e) => {
                  setResetPassword((prev) => ({
                    ...prev,
                    confirmPassword: e.target.value,
                  }));
                }}
                type="password"
                className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
              ></input>
            </div>
          </div>
        )}
      </Modal>
      <div
        style={{
          display:
            window.innerWidth < 768 ? "none" : isSidebarOpen ? "none" : "flex",
          flexDirection: "column",
          position: window.innerWidth < 768 ? "fixed" : "static",
          top: 0,
          left: 0,
        }}
        className="hidden transition-all md:w-[6%] shadow-xl xl:w-[4%] 2xl:w-[3%] md:z-0 z-50 w-[100%] h-screen bg-[#b1b0b0] rounded-tr-3xl"
      >
        <div className="p-4">
          {isSidebarOpen ? (
            <MenuUnfoldOutlined
              className="text-white text-xl sm:text-2xl"
              onClick={() => setIsSidebarOpen(false)}
            />
          ) : (
            <div>
              <MenuFoldOutlined
                className="text-white text-xl sm:text-2xl"
                onClick={() => setIsSidebarOpen(true)}
              />
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          display: isSidebarOpen ? "flex" : "none",
          flexDirection: "column",
          position: window.innerWidth < 768 ? "fixed" : "static",
          top: 0,
          left: 0,
        }}
        className="hidden md:w-[22%] shadow-xl xl:w-[20%] 2xl:w-[14%] md:z-0 z-50 w-[100%] h-screen bg-photo-time-pink-patel max-sm:bg-white rounded-tr-3xl"
      >
        <div className="text-ok-travel-green h-[40%] border-gray-300 flex-col md:flex hidden uppercase font-bold rounded-tr-3xl">
          <div className="2xl:p-6 xl:p-4 p-3">
            {isSidebarOpen ? (
              <MenuUnfoldOutlined
                className="text-white text-xl sm:text-2xl"
                onClick={() => setIsSidebarOpen(false)}
              />
            ) : (
              <div>
                <MenuFoldOutlined
                  className="text-white text-xl sm:text-2xl"
                  onClick={() => setIsSidebarOpen(true)}
                />
              </div>
            )}
          </div>
          <div className="flex h-full flex-col w-auto justify-center items-center">
            <span className="text-photo-time-pink-main font-bold 2xl:text-[52px] xl:text-[48px] lg:text-[40px] text-[36px]">
              PHOTO
            </span>
            <span className="text-photo-time-pink-main font-bold 2xl:text-[52px] xl:text-[48px] lg:text-[40px] text-[36px] xl:-mt-3">
              TIME
            </span>
          </div>
        </div>
        {/* thoong tin treen */}
        <div className="md:hidden p-6 border-b-[1px] justify-between flex items-center gap-4">
          <div className="flex items-center gap-3 w-full">
            <img
              src={infoDetail?.data?.url}
              alt="Profile"
              className="w-10 h-10 border-[1px] border-gray-300 p-[1px] rounded-full"
            />
            <div className="flex flex-col justify-start items-start">
              <span className="text-ok-travel-green flex items-center text-photo-time-pink-main font-semibold sm:text-base text-sm md:hidden">
                {`${infoDetail?.data?.firstName} ${infoDetail?.data?.lastName}`}
              </span>
              <button
                onClick={handleLogout}
                className="text-gray-600 font-medium hover:underline text-sm"
              >
                Logout
              </button>
            </div>
          </div>
          <div
            onClick={() => setIsSidebarOpen(false)}
            className="cursor-pointer p-2 rounded-full bg-gray-100 hover:bg-gray-200"
          >
            <IoMdClose size={22} color="black"></IoMdClose>
          </div>
        </div>
        {/* menu */}
        <div className="rounded-tl-3xl rounded-tr-3xl border-none h-screen bg-white overflow-y-scroll custom-scrollbar">
          {infoDetail?.data?.url && (
            <div className="w-full flex justify-center items-center max-md:hidden">
              <img
                src={infoDetail?.data?.url}
                className="mt-4 w-[60px] h-[60px] rounded-full"
              ></img>
            </div>
          )}

          <div className="xl:h-[10vh] justify-center flex items-center gap-2 xl:px-5 md:h-[9vh] h-[8vh] max-lg:hidden">
            <button className="outline-none flex justify-center items-center xl:gap-4 gap-2">
              {/* <img
                src={phototime_logo}
                alt="Profile"
                className="w-12 h-12 border-[1px] border-gray-300 p-[1px] rounded-full"
              /> */}
              <span className="text-gray-800 font-semibold hidden md:inline">{`${infoDetail?.data?.firstName} ${infoDetail?.data?.lastName}`}</span>
            </button>
          </div>
          <Menu
            mode="inline"
            defaultSelectedKeys={["231"]}
            selectedKeys={stateOpenKeys}
            openKeys={stateOpenKeys}
            onOpenChange={onOpenChange}
            onClick={onMenuClick}
            style={{ width: "100%", flexGrow: 1 }}
            items={items}
          />
        </div>
        <div className="w-[100%] border-none -mt-1 md:flex hidden gap-3 justify-center bg-white pb-6 items-center">
          <button
            onClick={handleLogout}
            className="flex md:gap-1 lg:gap-2 border-none items-center w-[70%] rounded-full justify-between xl:px-8 px-6 md:py-2 
            py-1 max-xl:py-[4px] hover:bg-opacity-80 text-small md:text-base bg-[#8f8f8f] bg-opacity-70 text-ok-travel-green-light cursor-pointer"
          >
            <span className="text-white">Logout</span>
            <IoIosLogOut color="#ffff" size={26}></IoIosLogOut>
          </button>
          <div
            // onClick={showModal}
            onClick={() => {
              navigate(path.ACOOUNT_MANAGER);
            }}
            className="p-[8px] border-[1px] border-gray-800 rounded-lg cursor-pointer"
          >
            <IoSettingsSharp />
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Sidebar);
